import { useEffect, useState } from "react";
import { getDMs, handleDM, getClients } from "./opsApi";
import { Inbox, Check } from "lucide-react";

const badge = { nuevo: "bg-blue-500/20 text-blue-300", atendido: "bg-emerald-500/20 text-emerald-300", tomado: "bg-amber-500/20 text-amber-300" };

export default function OpsDMs() {
  const [rows, setRows] = useState([]);
  const [clients, setClients] = useState([]);
  const [replies, setReplies] = useState({});

  const load = () => { getDMs().then(setRows).catch(() => {}); getClients().then(setClients).catch(() => {}); };
  useEffect(() => { load(); }, []);

  const mark = async (id, status) => { await handleDM(id, { status, reply: replies[id] || "" }); load(); };
  const cname = (id) => clients.find((c) => c.id === id)?.name || "—";

  return (
    <div data-testid="ops-dms">
      <h2 className="mb-2 flex items-center gap-2 font-serif text-2xl font-bold text-white"><Inbox className="h-6 w-6 text-[#AC3333]" /> Bandeja de Mensajes (DMs)</h2>
      <p className="mb-5 text-xs text-white/40">Mensajes entrantes que atiende la Ruta 1 de n8n. Puedes supervisar, responder o tomar control manual.</p>
      <div className="space-y-3">
        {rows.map((d) => (
          <div key={d.id} data-testid={`ops-dm-${d.id}`} className="rounded-2xl border border-white/10 bg-[#241010] p-4">
            <div className="flex flex-wrap items-center gap-2">
              <span className={`rounded-full px-2 py-0.5 text-[11px] ${badge[d.status] || badge.nuevo}`}>{d.status}</span>
              <span className="text-sm font-semibold text-white">{d.from_user || "Usuario"}</span>
              <span className="text-xs text-white/40">{d.platform} · {cname(d.client_id)}</span>
            </div>
            <p className="mt-2 text-sm text-white/80">{d.text}</p>
            {d.reply && <p className="mt-1 text-xs text-emerald-300">Respuesta: {d.reply}</p>}
            {d.status !== "atendido" && (
              <div className="mt-3 flex flex-wrap items-center gap-2">
                <input data-testid={`ops-dm-reply-${d.id}`} value={replies[d.id] || ""} onChange={(e) => setReplies({ ...replies, [d.id]: e.target.value })} placeholder="Escribe una respuesta / nota…" className="flex-1 rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none focus:border-[#AC3333]" />
                <button data-testid={`ops-dm-take-${d.id}`} onClick={() => mark(d.id, "tomado")} className="rounded-lg border border-white/15 px-3 py-2 text-xs text-white/70 hover:border-white/40">Tomar control</button>
                <button data-testid={`ops-dm-done-${d.id}`} onClick={() => mark(d.id, "atendido")} className="flex items-center gap-1 rounded-lg bg-emerald-600 px-3 py-2 text-xs font-semibold text-white hover:bg-emerald-500"><Check className="h-3.5 w-3.5" /> Atendido</button>
              </div>
            )}
          </div>
        ))}
        {rows.length === 0 && <p className="text-sm text-white/40">Sin mensajes por ahora. n8n los enviará a <code className="text-white/60">POST /api/ops/dms/ingest</code>.</p>}
      </div>
    </div>
  );
}
